<template>
  <div>

      <!--EAN Input-->
      <form @submit="search()">
        <div class="form-group">
          <div class="input-group">
            <input type="text" v-model="ean" class="form-control form-control-lg" placeholder="Čiarový kód" autofocus>
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary" @click="openBarcodeScanner()">
                <icon icon="barcode-read"></icon>
              </button>
            </div>
          </div>
        </div>
      </form>

      <!--EAN Modal-->
      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                <span v-if="loadingScanner">Načítavam skener</span>
                <span v-else>Umiestni kód do záberu</span>
              </h5>
              <button type="button" class="close" @click="closeBarcodeScanner()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div id="interactive" class="viewport"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-backdrop fade show" id="backdrop" style="display: none;"></div>

      <!--Loading-->
      <alert v-if="loading">
        <div class="spinner-border" role="status"></div>
        <span class="ml-3">Hľadám...</span>
      </alert>

      <!--Not found-->
      <div v-if="article === false && loading === false" class="alert alert-warning d-flex align-items-center mt-4" role="alert">
        <i class="far fa-sad-cry fa-2x"></i>
        <span class="ml-3">Pre čiarový kód <b>{{ eanFound }}</b> nebol nájdený žiaden produkt.</span>
      </div>

      <!--Article table-->
      <div v-if="article && loading === false">
        <table class="table table-striped table-bordered my-4">
          <tbody>
          <tr v-if="article.name" class="table-success">
            <td class="text-nowrap"><b>Názov</b></td>
            <td><b>{{ article.name }}</b></td>
          </tr>
          <tr v-if="article.ean">
            <td class="text-nowrap"><b>Čiarový kód</b></td>
            <td>{{ article.ean }}</td>
          </tr>
          <tr v-if="article.goodsid">
            <td class="text-nowrap"><b>Goods ID</b></td>
            <td>{{ article.goodsid }}</td>
          </tr>
          <tr v-if="article.article">
            <td class="text-nowrap"><b>Article</b></td>
            <td>{{ article.article }}</td>
          </tr>
          <tr v-if="article.brand">
            <td class="text-nowrap"><b>Brand</b></td>
            <td>{{ article.brand }}</td>
          </tr>
          <tr v-if="article.color">
            <td class="text-nowrap"><b>Farba</b></td>
            <td>{{ article.color }}</td>
          </tr>
          </tbody>
        </table>

        <form :action="route" method="POST" enctype="multipart/form-data">

          <input type="hidden" name="ean" value="5051714917103">
          <input type="hidden" name="_token" :value="csrf">

          <div class="form-group mb-4">
            <div class="custom-file">
              <input type="file" class="custom-file-input" id="file" name="file" capture="environment" accept="image/*" @change="compressFiles">
              <label class="custom-file-label" for="file">Nahraj fotografiu</label>
            </div>
          </div>

          <div v-if="compressedImages.length">
            <h5>Fotografie <span class="badge badge-primary">{{ compressedImages.length }}</span></h5>
            <ul class="list-group mb-4">
              <li v-for="(file, index) in compressedImages" class="list-group-item p-3">
                <input type="hidden" name="fileBase64[]" :value="`${file.prefix} ${file.data}`">
                <div class="d-flex align-items-center justify-content-between">
                  <img :src="`${file.prefix} ${file.data}`" :alt="file.alt" width="100">
                  <span>{{ file.alt }}</span>
                  <button type="button" @click="compressedImages.splice(index,  1)" class="btn btn-sm btn-danger">
                    <span><icon icon="trash"></icon></span>
                  </button>
                </div>
              </li>
            </ul>
          </div>

          <div>
            <input type="submit" v-if="compressedImages.length > 0" :value="`Nahrať ${compressedImages.length} fotografií`" class="btn btn-primary">
            <button @click="article = null" class="btn btn-outline-danger">Zrušiť upload</button>
          </div>

        </form>



      </div>

  </div>
</template>

<script>
import Alert from './Alert.vue';
import Quagga from "quagga";
import * as Helper from '../modules/Helper';
import Compress from 'compress.js'
const compress = new Compress();

export default {
  props: {
    route: String
  },
  components: {
    Alert
  },
  data: function() {
    return {
      ean: '',
      eanFound: '',
      loading: false,
      loadingScanner: false,
      article: null,
      compressedImages: [],
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    }
  },
  methods: {
    search() {
      event.preventDefault();
      let _this = this;
      let url = `https://cdb.vermont.eu/api/picture-gallery/v1/articlebyean?key=gnITKvNwl99C0O6PWMtUei4dhdIjL7G2P&ean=${this.ean}`;
      this.loading = true;
      axios.get(url).then(response => {
        _this.article = response.data.article;
        this.eanFound = this.ean;
        this.ean = '';
        this.loading = false;
      });
    },
    compressFiles(event) {
      let _this = this;
      const files = [...event.target.files];
      compress.compress(files, {
        size: 1,
        quality: 0.75,
        maxWidth: 1280,
        maxHeight: 1280,
        resize: true
      }).then(data => {
        _this.compressedImages.push(data[0]);
        event.target.value = '';
      })
    },
    openBarcodeScanner() {
      document.getElementById("backdrop").style.display = "block";
      document.getElementById("exampleModal").style.display = "block";
      document.getElementById("exampleModal").classList.add("show");

      this.loadingScanner = true;

      Quagga.init({
        inputStream: {
          name: "Live",
          type: "LiveStream",
          constraints: {
            width: 640,
            height: 480,
          },
          area: {
            top: "0%",
            right: "0%",
            left: "0%",
            bottom: "0%"
          },
        },
        decoder: {
          readers: [
            "ean_reader"
          ],
        }
      }, err => {
        if (err) {
          console.log(err);
          return
        }
        this.loadingScanner = false;
        Quagga.start();
      });

      Quagga.onProcessed(function(result) {
        let drawingCtx = Quagga.canvas.ctx.overlay;
        let drawingCanvas = Quagga.canvas.dom.overlay;

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
            result.boxes.filter(function (box) {
              return box !== result.box;
            }).forEach(function (box) {
              Quagga.ImageDebug.drawPath(box, {x: 0, y: 1}, drawingCtx, {color: "green", lineWidth: 2});
            });
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, {x: 0, y: 1}, drawingCtx, {color: "#00F", lineWidth: 2});
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(result.line, {x: 'x', y: 'y'}, drawingCtx, {color: 'red', lineWidth: 3});
          }
        }
      });

      let _this = this;
      let allResults = [];

      Quagga.onDetected(function(result) {
        let currentResult = result.codeResult.code;
        allResults.push(currentResult);

        if (allResults.length > 20) {
          _this.ean = Helper.getHighestOccurenceInArray(allResults);
          allResults = [];
          _this.closeBarcodeScanner();
          Quagga.stop();
          _this.search();
        }

      });

    },
    closeBarcodeScanner() {
      document.getElementById("backdrop").style.display = "none";
      document.getElementById("exampleModal").style.display = "none";
      document.getElementById("exampleModal").classList.remove("show");
    }
  }
}
</script>
